import { AdStoreProviderParams } from '@/store/AdStoreProviderParams'
import { AdProviderNames } from '@/types'

import { AD_STORE_DEFAULT_PROVIDERS_FOR_GAME_PAGE } from '../../../../store/constants'
import { AdSenseExperiment } from './AdSenseExperiment'

export function getAdSenseExperimentParameters({
    h5AdsWaterfallExperimentSample,
}: {
    h5AdsWaterfallExperimentSample: string | undefined
}): AdStoreProviderParams | undefined {
    const AD_SENSE_EXPERIMENTS_PROVIDERS = {
        group_control: AD_STORE_DEFAULT_PROVIDERS_FOR_GAME_PAGE,
        group_1: [AdProviderNames.GOOGLE_INSTREAM, AdProviderNames.GOOGLE_AD_SENSE],
    }

    let forcedExperimentName: AdSenseExperiment | undefined

    // For experiment debugging, allows enabling a specific sample through the adsense_exp parameter
    const locationUrl = new URL(window.location.href)
    const locationSearchParams = new URLSearchParams(locationUrl.search)
    const locationSearchParamsExp = locationSearchParams.get('adsense_exp')
    if (locationSearchParamsExp && AD_SENSE_EXPERIMENTS_PROVIDERS[locationSearchParamsExp as AdSenseExperiment]) {
        forcedExperimentName = locationSearchParamsExp as AdSenseExperiment
    }

    const experimentName: AdSenseExperiment | undefined = (() => {
        if (forcedExperimentName) {
            return forcedExperimentName
        }

        const experimentSample = h5AdsWaterfallExperimentSample as AdSenseExperiment | undefined
        if (!experimentSample) {
            return undefined
        }

        if (!AD_SENSE_EXPERIMENTS_PROVIDERS[experimentSample]) {
            return undefined
        }

        return experimentSample
    })()

    if (!experimentName) {
        return undefined
    }

    const providers = AD_SENSE_EXPERIMENTS_PROVIDERS[experimentName]
    const resultProviderParams: AdStoreProviderParams = {
        providers,
        exp: experimentName,
    }

    return resultProviderParams
}
